/* unplugin-vue-components disabled */import { render } from "./Settings.vue?vue&type=template&id=7d7e7514&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=7d7e7514&lang=less&scoped=true"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7e7514"]])

export default __exports__